<template>

  <v-dialog
      v-model="dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          color="green lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
          small
      >
        VER
      </v-btn>
    </template>

    <convenio-card v-if="convenio" :convenio="convenio" />
  </v-dialog>



</template>
<script>


import ConvenioProvider from "@/modules/cobrox/providers/ConvenioProvider";
import ConvenioCard from "@/modules/cobrox/components/ConvenioCard/ConvenioCard.vue";

export default {
  name: 'convenio-dialog',
  components: {ConvenioCard},
  props: {
    convenioId: {type: String, required: true},
  },
  data() {
    return {
      dialog: false,
      convenio: null,
      loading: true,
    }
  },
  mounted() {
    this.findConvenio();
  },
  methods: {
   findConvenio() {
     this.loading = true;
     ConvenioProvider.findConvenio(this.convenioId)
         .then(r => {
           this.convenio = r.data.findConvenio;
         })
         .catch(e => {
           console.error(e);
         })
         .finally(() => {
           this.loading = false;
         });
   }
  }
}
</script>
